import Layout, { LayoutType } from '../../types/layout';
import StoreFooter from '../StoreFooter';
import BannerListing from './BannerListing';
import BestOffers from './BestOffers';
import BottomSheetListing from './BottomSheetListing';
import BrowseCategoryListing from './BrowseCategoryListing';
import CarShopListing from './CarShopListing';
import CategoryCoverListing from './CategoryCoverListing';
import CategoryListing from './CategoryListing';
import CenteredCardListing from './CenteredCardListing';
import CurvedCarousel from './CurvedCarousel';
import FilterListing from './FilterListing';
import { FilterScrollListing } from './FilterScrollListing/FilterScrollListing';
import FlashListing from './FlashListing';
import FloatingScrollListing from './FloatingScrollListing';
import FullWidthBannerListing from './FullWidthBannerListing';
import GridListing from './GridListing';
import GridSaleListing from './GridSaleListing';
import GridScrollListing from './GridScrollListing';
import ImageGridListing from './ImageGridListing';
import ImageScrollListing from './ImageScrollListing';
import MarqueeListing from './MarqueeListing';
import PotdListing from './PotdListing';
import ScrollListing from './ScrollListing';
import TrendingDeals from './TrendingDeals';
import VideoCarousel from './VideoCarousel';
import VideoListing from './VideoListing';
// import VoteToSlash from './VoteToSlash';
import WeekendListing from './WeekendListing';

type PropType = {
  data: Layout[];
};
export const Layouts = ({ data }: PropType) => {
  return (
    <div>
      {data?.map(
        (item: Layout, index: number) =>
          ({
            [LayoutType.BestDealsListing]: <CurvedCarousel data={item} />,
            [LayoutType.GridListing]: <GridListing data={item} />,
            [LayoutType.CategoryCoverListing]: <CategoryCoverListing data={item} />,
            [LayoutType.GridListingSale]: <GridSaleListing data={item} />,
            [LayoutType.BannerListing]: (
              <BannerListing data={item} autoplay={item?.metaData?.autoplay} index={index} />
            ),
            [LayoutType.StackListing]: <TrendingDeals data={item} index={index} />,
            [LayoutType.CenteredCardListing]: <CenteredCardListing data={item} index={index} />,
            [LayoutType.ScrollListing]: <ScrollListing data={item} index={index} />,
            [LayoutType.GridScrollListing]: <GridScrollListing data={item} index={index} />,
            [LayoutType.ImageScrollListing]: <ImageScrollListing data={item} index={index} />,
            [LayoutType.ImageGridScrollListing]: <ImageGridListing data={item} index={index} />,
            [LayoutType.CategoryListing]: <CategoryListing data={item} index={index} />,
            [LayoutType.FullWidthBannerListing]: (
              <FullWidthBannerListing data={item} index={index} />
            ),
            [LayoutType.FilterListing]: <FilterListing data={item} index={index} />,
            [LayoutType.BrowseCategoryListing]: <BrowseCategoryListing data={item} />,
            [LayoutType.MarqueeListing]: <MarqueeListing data={item} />,
            [LayoutType.VideoListing]: <VideoListing data={item} />,
            [LayoutType.VideoCarousel]: <VideoCarousel data={item} />,
            [LayoutType.WeekendManiaListing]: <WeekendListing data={item} index={index} />,
            [LayoutType.FlashListing]: <FlashListing data={item} index={index} />,
            [LayoutType.BestOffersListing]: <BestOffers data={item} />,
            [LayoutType.FilterScrollListing]: <FilterScrollListing data={item} />,
            [LayoutType.ProductSuggestion]: <StoreFooter />,
            [LayoutType.StripBannerListing]: <CarShopListing data={item} />,
            [LayoutType.FloatingScrollListing]: <FloatingScrollListing data={item} />,
            [LayoutType.ProductOfTheDayListing]: <PotdListing data={item} />,
            [LayoutType.BottomSheetListing]: <BottomSheetListing data={item} index={index} />,
          })[item?.layoutType],
      )}
    </div>
  );
};
